import { observer } from 'mobx-react-lite'
import React from 'react'
import { Dropdown, type IDropdownItem, Tooltip } from 'shared/ui'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { type IWhenDateFieldPeriod } from 'entities/Campaign'
import { whenDateFieldsPeriodConfig } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/type'
import { useScheduleDateFiledContext } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/context/sendLaterContext'
import styles from './styles.module.scss'

export const WhenDropdown = observer(({ dropdownId }: { dropdownId: string }) => {
  const { when, setWhen } = useScheduleDateFiledContext()

  const whenItems: IDropdownItem[] = Object.entries(whenDateFieldsPeriodConfig).map(
    ([key, value]) => ({
      id: key,
      label: value,
      activeValue: when === key,
    })
  )

  const handleChangeWhen = (item: IDropdownItem) => {
    setWhen(item.id as IWhenDateFieldPeriod)
  }
  return (
    <Dropdown
      width={330}
      parentsDropdownId={[dropdownId]}
      items={whenItems}
      onChange={handleChangeWhen}
      margin={0}
      triggerComponent={() => (
        <Tooltip label={'When'} placement={'left'} fullWidth>
          <div>
            <TextFieldPlaceholder
              variant={'outline'}
              size={'small'}
              leftActions={[
                makeTextFieldIcon({
                  icon: 'arrowLinesHorizontal',
                  className: styles.icon,
                }),
              ]}
              rightActions={[
                makeTextFieldIcon({
                  icon: 'chevronDown',
                  color: 'var(--content-neutral-primary)',
                }),
              ]}
              placeholder={whenDateFieldsPeriodConfig[when]}
            />
          </div>
        </Tooltip>
      )}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              offset: ({ reference }) => {
                return [0, -reference.height - 4]
              },
            },
          },
        ],
      }}
    />
  )
})
